import { Component, Input, inject } from '@angular/core';
import {VwuiModalService} from '@bvgo-ict/vwui-angular';
import {BehaviorSubject, Observable} from 'rxjs';
import {Mode} from '../../../models/mode';
import {switchMap} from 'rxjs/operators';
import {PrdRelationModalComponent} from '../relation-modal/prd-relation-modal.component';
import {ProjectRelationService} from '../../../services/project-relation.service';
import {ProjectRelation} from '../../../models/project-relation';
import {ToastrService} from 'ngx-toastr';

@Component({
    selector: 'app-prd-relations',
    templateUrl: './prd-relations.component.html',
    standalone: false
})
export class PrdRelationsComponent {
    private projectRelationService = inject<ProjectRelationService>('ProjectRelationService' as any);
    private toast = inject(ToastrService);
    private vwuiModalService = inject(VwuiModalService);

    @Input() refId!: number;
    @Input() mode$: Observable<Mode> | undefined;

    refresh$ = new BehaviorSubject<void>(undefined);
    relations$ = this.refresh$.pipe(
        switchMap(() => this.projectRelationService.list(this.refId))
    );

    openRelationModal(existingRelation?: ProjectRelation) {
        this.vwuiModalService.open(
            PrdRelationModalComponent,
            {
                closeOnBackdropClick: false,
                data: {relation: existingRelation, refId: this.refId}
            }
        ).afterClosed.subscribe(relation => {
            if (relation) {
                this.refresh$.next();
            }
        });
    }

    async deleteRelation(relation: ProjectRelation) {
        if (!window.confirm('Weet u zeker dat u deze projectrelatie wilt verwijderen?')) {
            return;
        }

        try {
            await this.projectRelationService.delete(this.refId, relation.id).toPromise();
            this.refresh$.next();
        } catch (error) {
            console.error(error);
            this.toast.error('Projectrelatie kon niet verwijderd worden.');
        }
    }

}
